import { GTMService } from '../services/gtm.service.js';

export class SearchAnalyticsService {
    static trackSearch(query, unfilteredNumberOfHits, searchType = 'intern søgning') {
        GTMService.pushToDataLayer([
            {
                'event': 'track-event',
                'eventCategory': searchType,
                'eventAction': "submit",
                'eventLabel': query,
                'eventValue': unfilteredNumberOfHits,
                'eventNoninteraction': true,
                'searchNumresult': unfilteredNumberOfHits
            }
        ]);
    }
}